/* eslint-disable no-undef */
(function () {
  'use strict'

  angular.module('MktzapApp.Factories')
    .factory('CountryService', CountryService)

  CountryService.$inject = ['$resource']

  function CountryService ($resource) {
    return $resource(apiUrl + '/country', {}, {
      store: { method: 'POST', params: {}, isArray: false },
      update: { method: 'PATCH', params: {}, isArray: false },
      delete: { method: 'DELETE', params: {}, isArray: false },
      getCountries: { url: apiUrl + '/country/get-countries', method: 'GET', params: {}, isArray: false }
    })
  }
// eslint-disable-next-line semi
})();
